/* eslint-disable no-void */
import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.UserListsResponse,
  fetchUserLists: (PartnerID: string ) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;


const useFetchUserLists: ApiHook = ({ api }) => {
  const source = axios.CancelToken.source();
  const [shouldFethUserList, setShouldFethUserList] = useState(false);

  const [params, setParams] = useState<string>();

  const [response, setResponse] = useState<vp.UserListsResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldFethUserList) return () => {};

    const FetchUserList = async () => {
      const res = await api.fetchUserLists({PartnerID: params} as any, source);
      setResponse(res);
    };

    if (shouldFethUserList) void FetchUserList();
    setShouldFethUserList(false);
    return () => {
      source.cancel();
    };
  }, [shouldFethUserList]);

  return [
    response,
    (_params: string | undefined) => {
      setParams(_params);
      setShouldFethUserList(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldFethUserList(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchUserLists);